<template>
    <div class="cupons-table-page weeduc-admin-page text-start p-0">
        <header class="weeduc-admin-page__header">
            <div class="weeduc-admin-page__header-lead">
                <TitlePage
                    :title="$t('admin.coupons.title')"
                    :subtitle="$t('admin.coupons.subtitleManage')"
                    :hasMargin="false"
                />
            </div>
            <div class="weeduc-admin-page__header-actions">
                <v-btn
                    variant="flat"
                    color="primary"
                    rounded="lg"
                    :title="$t('admin.coupons.createNewTitle')"
                    :icon="$vuetify.display.xs"
                    class="text-none edit-courses-new-btn"
                    @click="newCupomDialog = true"
                >
                    <template v-if="$vuetify.display.xs">
                        <v-icon>mdi-plus</v-icon>
                    </template>
                    <template v-else>
                        <v-icon class="me-1" size="small">mdi-plus</v-icon>
                        {{ $t('admin.coupons.new') }}
                    </template>
                </v-btn>
            </div>
        </header>

        <div class="weeduc-admin-page__shell">
            <div class="weeduc-admin-page__panel">
                <div class="weeduc-admin-page__toolbar">
                    <v-row align="end" dense>
                        <v-col cols="12" sm="7" md="5" lg="4">
                            <v-text-field
                                v-model="searchTerm"
                                :label="$t('common.search')"
                                :placeholder="$t('admin.coupons.searchPlaceholder')"
                                class="inputd weeduc-admin-v-field"
                                variant="outlined"
                                density="compact"
                                hide-details
                                clearable
                                append-inner-icon="mdi-magnify"
                                @update:model-value="onSearch"
                            />
                        </v-col>
                        <v-col cols="12" sm="5" md="4" lg="4">
                            <v-select
                                v-model="statusFilter"
                                :items="statusFilterOptions"
                                item-title="text"
                                item-value="value"
                                :label="$t('common.status')"
                                variant="outlined"
                                class="inputd weeduc-admin-v-field"
                                :menu-props="adminSelectMenuProps"
                                @update:modelValue="getCupomData()"
                                density="compact"
                                hide-details
                            />
                        </v-col>
                    </v-row>
                </div>

                <div class="weeduc-admin-page__table-section">
                    <v-table class="custom-table">
                        <thead>
                            <tr>
                                <th class="cupons-table__name-column">
                                    Título
                                </th>
                                <th>{{ $t('admin.coupons.code') }}</th>
                                <th class="text-center">{{ $t('common.status') }}</th>
                                <th class="text-center">{{ $t('admin.coupons.expiration') }}</th>
                                <th class="text-center">{{ $t('admin.coupons.discount') }}</th>
                                <th class="text-center">{{ $t('common.edit') }}</th>
                                <th class="text-center">{{ $t('common.delete') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="cupom in cuponsData" :key="cupom.id">
                                <td class="cupons-table__name-column">
                                    {{ cupom.title }}
                                </td>
                                <td>{{ cupom.code }}</td>
                                <td class="text-center">
                                    <v-chip
                                        density="compact"
                                        :color="
                                            cupom.status == 1
                                                ? 'success'
                                                : 'danger'
                                        "
                                    >
                                        {{
                                            cupom.status && cupom.status == 1
                                                ? $t('common.active')
                                                : $t('common.inactive')
                                        }}
                                    </v-chip>
                                </td>
                                <td class="text-center">
                                    <div class="d-flex justify-content-center">
                                        <v-tooltip
                                            v-if="
                                                getCouponStatus(cupom.expired)
                                                    .showTooltip
                                            "
                                            :text="
                                                getCouponStatus(cupom.expired)
                                                    .message
                                            "
                                            location="top"
                                        >
                                            <template
                                                v-slot:activator="{ props }"
                                            >
                                                <div
                                                    v-bind="props"
                                                    style="
                                                        display: flex;
                                                        align-items: center;
                                                        gap: 5px;
                                                    "
                                                >
                                                    <span
                                                        :style="{
                                                            color: getCouponStatus(
                                                                cupom.expired
                                                            ).color,
                                                        }"
                                                    >
                                                        {{
                                                            new Date(
                                                                cupom.expired
                                                            ).toLocaleDateString()
                                                        }}
                                                    </span>
                                                    <Icon 
                                                        :name="getCouponStatus(cupom.expired).icon" 
                                                        size="20"
                                                        :style="{
                                                            color: getCouponStatus(
                                                                cupom.expired
                                                            ).iconFill,
                                                        }"
                                                    />
                                                </div>
                                            </template>
                                        </v-tooltip>
                                        <span v-else>
                                            {{
                                                new Date(
                                                    cupom.expired
                                                ).toLocaleDateString()
                                            }}
                                        </span>
                                    </div>
                                </td>
                                <td class="text-center">
                                    {{ cupom.discount }}%
                                </td>
                                <td class="text-center">
                                    <v-btn
                                        color="heading"
                                        @click="editCupom(cupom)"
                                        :title="$t('admin.coupons.editCouponTitle')"
                                        icon
                                        variant="text"
                                    >
                                        <Icon name="pencil" size="20" />
                                    </v-btn>
                                </td>
                                <td class="text-center">
                                    <v-btn
                                        color="danger"
                                        variant="text"
                                        @click="openDeleteModal(cupom.id)"
                                        icon
                                        :title="$t('admin.coupons.deleteCouponTitle')"
                                    >
                                        <Icon name="trash" size="20" />
                                    </v-btn>
                                </td>
                            </tr>
                        </tbody>
                    </v-table>
                </div>

                <v-responsive class="weeduc-admin-page__pagination">
                    <v-pagination
                        v-model="currentPage"
                        :length="totalPages"
                        :total-visible="5"
                        :disabled="isLoading"
                        @update:model-value="getCupomData"
                    ></v-pagination>
                </v-responsive>

                <Loader :isActive="!isLoading" />
            </div>
        </div>

        <!-- Dialog Novo Cupom -->
        <v-dialog v-model="newCupomDialog" :max-width="600">
            <v-card class="modal-card">
                <v-card-title>
                    <h3 class="mb-0">{{ $t('admin.coupons.createModalTitle') }}</h3>
                </v-card-title>
                <v-card-text>
                    <v-text-field
                        v-model="newCupom.title"
                        :label="$t('admin.coupons.couponTitle')"
                        :placeholder="$t('admin.coupons.couponTitle')"
                        required
                        class="inputd mb-3 mb-md-4"
                        variant="outlined"
                        hide-details
                        density="compact"
                    ></v-text-field>
                    <v-text-field
                        v-model="newCupom.code"
                        :label="$t('admin.coupons.couponCode')"
                        :placeholder="$t('admin.coupons.couponCode')"
                        required
                        class="inputd mb-3 mb-md-4"
                        variant="outlined"
                        hide-details
                        density="compact"
                    ></v-text-field>
                    <v-text-field
                        v-model="newCupom.discount"
                        label="Desconto (%)"
                        placeholder="Desconto (%)"
                        type="number"
                        required
                        class="inputd mb-3 mb-md-4"
                        variant="outlined"
                        hide-details
                        density="compact"
                    ></v-text-field>
                    <v-text-field
                        v-model="newCupom.expired"
                        label="Data de Vencimento"
                        type="date"
                        placeholder="dd/mm/aaaa"
                        required
                        class="inputd mb-3 mb-md-4"
                        variant="outlined"
                        hide-details
                        density="compact"
                    ></v-text-field>
                    <v-select
                        v-model="newCupom.courses"
                        :items="coursesList"
                        item-title="couponLabel"
                        item-value="id"
                        label="Cursos ou grupos (opcional)"
                        placeholder="Cursos ou grupos (opcional)"
                        class="inputd"
                        variant="outlined"
                        hide-details
                        density="compact"
                    ></v-select>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        class="flex-grow-1 cancel-btn"
                        color="grey-darken-4"
                        variant="tonal"
                        @click="newCupomDialog = false"
                        >Cancelar</v-btn
                    >
                    <v-btn
                        class="flex-grow-1"
                        color="primary"
                        variant="flat"
                        @click="createNewCupom"
                        :disabled="!newCupom.title || isLoading"
                        :loading="isLoading"
                        >Criar</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialog Editar Cupom -->
        <v-dialog v-model="editCupomDialog" :max-width="600">
            <v-card class="modal-card">
                <v-card-title>
                    <h3 class="mb-0">Editar Cupom</h3>
                </v-card-title>
                <v-card-text class="dialog-content">
                    <div class="status-switch mb-3 mb-md-4">
                        <label>{{ $t('common.status') }}</label>
                        <v-switch
                            v-model="editingCupom.status"
                            :label="
                                editingCupom.status === 1 ? 'Ativo' : 'Inativo'
                            "
                            :true-value="1"
                            :false-value="0"
                            color="#2f2e8b"
                            class="dialog-switch"
                        ></v-switch>
                    </div>
                    <v-text-field
                        v-model="editingCupom.title"
                        :label="$t('admin.coupons.couponTitle')"
                        :placeholder="$t('admin.coupons.couponTitle')"
                        required
                        class="inputd mb-3 mb-md-4"
                        variant="outlined"
                        hide-details
                        density="compact"
                    ></v-text-field>
                    <v-text-field
                        v-model="editingCupom.code"
                        :label="$t('admin.coupons.couponCode')"
                        :placeholder="$t('admin.coupons.couponCode')"
                        required
                        class="inputd mb-3 mb-md-4"
                        variant="outlined"
                        hide-details
                        density="compact"
                    ></v-text-field>
                    <v-text-field
                        v-model="editingCupom.discount"
                        label="Desconto (%)"
                        placeholder="Desconto (%)"
                        type="number"
                        required
                        class="inputd mb-3 mb-md-4"
                        variant="outlined"
                        hide-details
                        density="compact"
                    ></v-text-field>
                    <v-text-field
                        v-model="editingCupom.expired"
                        label="Data de Vencimento"
                        type="date"
                        placeholder="dd/mm/aaaa"
                        required
                        class="inputd mb-3 mb-md-4"
                        variant="outlined"
                        hide-details
                        density="compact"
                    ></v-text-field>
                    <v-select
                        v-model="editingCupom.courses"
                        :items="coursesList"
                        item-title="couponLabel"
                        item-value="id"
                        label="Cursos ou grupos (opcional)"
                        placeholder="Cursos ou grupos (opcional)"
                        class="inputd"
                        variant="outlined"
                        hide-details
                        density="compact"
                    ></v-select>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        class="flex-grow-1 cancel-btn"
                        color="grey-darken-4"
                        variant="tonal"
                        @click="editCupomDialog = false"
                        >Cancelar</v-btn
                    >
                    <v-btn
                        class="flex-grow-1"
                        color="primary"
                        variant="flat"
                        @click="updateCupom(editingCupom.id)"
                        :disabled="!editingCupom.title || isLoading"
                        :loading="isLoading"
                        >Salvar</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialog Deletar Cupom -->
        <v-dialog v-model="isDeleteDialogVisible" :max-width="600">
            <v-card class="modal-card">
                <v-card-title>
                    <h3 class="mb-0">
                        Você tem certeza que deseja excluir esse cupom?
                    </h3>
                </v-card-title>
                <v-card-subtitle>
                    Esta ação não poderá ser desfeita.
                </v-card-subtitle>
                <v-card-text>
                    <p class="mb-1">
                        Título: <strong>{{ deletedCupom.title }}</strong>
                    </p>
                    <p class="mb-1">
                        Código: <strong>{{ deletedCupom.code }}</strong>
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        class="flex-grow-1 cancel-btn"
                        color="grey-darken-4"
                        variant="tonal"
                        @click="isDeleteDialogVisible = false"
                        >Cancelar</v-btn
                    >
                    <v-btn
                        class="flex-grow-1 text-white"
                        color="danger"
                        variant="flat"
                        :loading="isLoading"
                        :disabled="isLoading"
                        @click="confirmDelete"
                        >Excluir</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import { toast } from 'vue3-toastify';
    import { mapState } from 'vuex';
    import { debounce } from 'lodash';
    import ApiCupom from '@/utils/cupom';
    import ApiCourses, { unwrapSellableCatalog } from '@/utils/courses';
    import Loader from '@/components/Loader/loader.vue';
    import TitlePage from '@/components/Weflix/titlePage.vue';

    export default {
        components: {
            Loader,
            TitlePage,
        },
        data() {
            return {
                cuponsData: [],
                searchTerm: '',
                currentPage: 1,
                itemsPerPage: 12,
                totalPages: 0,
                isDeleteDialogVisible: false,
                deletedCupom: null,
                isLoading: false,
                statusFilter: '',
                statusFilterOptions: [
                    { text: 'Todos', value: '' },
                    { text: 'Ativo', value: 1 },
                    { text: 'Inativo', value: 0 },
                ],
                newCupomDialog: false,
                editCupomDialog: false,
                coursesList: [],
                newCupom: {
                    title: '',
                    code: '',
                    discount: '',
                    expired: '',
                    courses: null,
                },
                editingCupom: {
                    id: '',
                    title: '',
                    code: '',
                    discount: '',
                    expired: '',
                    status: 1,
                    courses: null,
                },
            };
        },
        computed: {
            ...mapState(['token', 'numberIntensTable', 'dark']),

            adminSelectMenuProps() {
                return this.dark
                    ? { contentClass: 'weeduc-admin-select-menu-dark' }
                    : {};
            },
        },
        created() {
            this.getCupomData();
            this.getCoursesList();
        },
        methods: {
            async getCoursesList() {
                try {
                    const response = await ApiCourses.getDataCourse(this.token);
                    this.coursesList = unwrapSellableCatalog(response);
                } catch (error) {
                    console.error('Erro ao carregar lista de cursos:', error);
                    this.coursesList = [];
                }
            },
            getCouponStatus(expiredDate) {
                const expirationDate = new Date(expiredDate);
                const currentDate = new Date();
                const timeDifference =
                    expirationDate.getTime() - currentDate.getTime();
                const daysDifference = Math.ceil(
                    timeDifference / (1000 * 60 * 60 * 24)
                );

                if (daysDifference < 0) {
                    return {
                        showTooltip: true,
                        message: this.$t('admin.coupons.expiredToast'),
                        color: '#dc3545',
                        iconColor: '#fee7e7',
                        iconFill: '#dc3545',
                        icon: 'alertCircle',
                    };
                }

                if (daysDifference >= 0 && daysDifference <= 7) {
                    return {
                        showTooltip: true,
                        message: 'Seu cupom vai expirar logo!',
                        color: '#ff9800',
                        iconColor: '#fff3e0',
                        iconFill: '#ff9800',
                        icon: 'alert',
                    };
                }

                return {
                    showTooltip: false,
                    message: '',
                    color: 'inherit',
                    iconColor: '',
                    iconFill: '',
                    icon: '',
                };
            },
            openDeleteModal(cupomId) {
                this.deletedCupom = this.cuponsData.find(
                    (cupom) => cupom.id === cupomId
                );
                if (!this.deletedCupom) {
                    toast.error(this.$t('admin.coupons.notFound'));
                    return;
                }
                this.isDeleteDialogVisible = true;
            },
            editCupom(cupom) {
                this.editingCupom = { 
                    ...cupom,
                    courses: Array.isArray(cupom.courses) && cupom.courses.length > 0 
                        ? cupom.courses[0] 
                        : (cupom.courses || null),
                };
                this.editCupomDialog = true;
            },
            async getCupomData() {
                try {
                    this.isLoading = true;
                    let status = this.statusFilter;
                    if (status === '') status = null;
                    let search =
                        this.searchTerm && this.searchTerm.trim() !== ''
                            ? this.searchTerm.trim()
                            : null;

                    const response = await ApiCupom.getDataCupons(
                        this.token,
                        this.currentPage - 1,
                        this.itemsPerPage,
                        status,
                        search
                    );
                    this.cuponsData = response.content || [];
                    this.totalPages = response.totalPages || 1;
                } catch (err) {
                    toast.error('Erro ao carregar listagem de cupons');
                } finally {
                    this.isLoading = false;
                }
            },
            async createNewCupom() {
                const payload = {
                    id: '',
                    title: this.newCupom.title,
                    code: this.newCupom.code,
                    defaul: 0,
                    status: 1,
                    expired: this.newCupom.expired,
                    discount: Number(this.newCupom.discount),
                    idCourse: this.newCupom.courses ? Number(this.newCupom.courses) : 0,
                };
                try {
                    this.isLoading = true;
                    await ApiCupom.createNewCupom(this.token, payload);
                    this.newCupomDialog = false;
                    this.newCupom = {
                        title: '',
                        code: '',
                        discount: '',
                        expired: '',
                        courses: null,
                    };
                    toast.success('Cupom criado com sucesso!');
                    this.getCupomData();
                } catch (err) {
                    toast.error('Erro ao criar cupom!');
                } finally {
                    this.isLoading = false;
                }
            },
            async updateCupom(id) {
                const payload = {
                    id: String(id),
                    title: this.editingCupom.title,
                    code: this.editingCupom.code,
                    defaul: 0,
                    status: this.editingCupom.status,
                    expired: this.editingCupom.expired,
                    discount: Number(this.editingCupom.discount),
                    idCourse: this.editingCupom.courses ? Number(this.editingCupom.courses) : 0,
                };
                try {
                    this.isLoading = true;
                    await ApiCupom.editCupom(this.token, id, payload);
                    this.editCupomDialog = false;
                    toast.success('Cupom atualizado com sucesso!');
                    this.getCupomData();
                } catch (err) {
                    toast.error('Erro ao atualizar cupom!');
                } finally {
                    this.isLoading = false;
                }
            },
            async confirmDelete() {
                if (this.deletedCupom) {
                    const payload = {
                        id: String(this.deletedCupom.id),
                        title: this.deletedCupom.title,
                        code: this.deletedCupom.code,
                        defaul: 0,
                        status: 0,
                        expired: this.deletedCupom.expired,
                        discount: Number(this.deletedCupom.discount),
                        idCourse: 0,
                    };
                    try {
                        this.isLoading = true;
                        await ApiCupom.editCupom(
                            this.token,
                            this.deletedCupom.id,
                            payload
                        );
                        toast.success(this.$t('admin.coupons.deleteSuccess'));
                        this.getCupomData();
                    } catch (error) {
                        toast.error('Erro ao excluir cupom:', error);
                    } finally {
                        this.isDeleteDialogVisible = false;
                        this.isLoading = false;
                        this.deletedCupom = { title: '', code: '' };
                    }
                }
            },
            onSearch: debounce(function () {
                this.getCupomData();
            }, 300),
        },
    };
</script>

<style scoped>
    @import url('@/css/weeduc/admin/dashboard-weflix-shell.css');
    @import url('@/css/weeduc/admin/cupons.css');
</style>
